import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Vehiculo, Conductor } from '../modelos/data-emision.model';
import { StorageService } from '../services/storage.service';
import { ValidaRFC } from '../utilities/validaRFC';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { LogConsumoFunciones } from '../utilities/logConsumo';
import { RequestServices } from '../services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CotizacionRenovacionComponent } from '../cotizacion/renovacion/cotizacion-ayuda.component';
import { MatDialog } from '@angular/material/dialog';
import { Configuration } from '../Constants/configuration';
import { validaSerie } from '../utilities/valida-noSerie';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';
import { SimpleMessageComponent } from '../tools/simple-message/simple-message.component';
import { from } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Prospecto } from '../modelos/prospecto.model';
import { OpcionesSeguros } from '../datos-emision-vehiculo/components/opciones-seguros.component';
import { FormControl } from '@angular/forms';
import { ValidacionesReactiveForm } from '../utilities/validacionesReactiveForm';
import { IfStmt } from '@angular/compiler';

declare var gtag;

@Component({
  selector: 'datos-emision-vehiculo',
  templateUrl: './datos-emision-vehiculo.component.html',
  styleUrls: ['./datos-emision-vehiculo.component.css']
})
export class DatosEmisionVehiculoRenovacionComponent {
  public const: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  value: string = "";
  vehiculo: Vehiculo = new Vehiculo();
  conductor: Conductor = new Conductor();
  dataContratante: any = {};
  cia: number = 0;
  muestraOtroConcductor: number = 0;
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  public validacionSerie: boolean = false;
  public validacionNoSerie: validaSerie = new validaSerie(this.requestService, this.storageService, this.router);
  public inputRef: boolean = false;
  public edadContratante: number = 0;
  public edadMismaProspecto: boolean = false;
  public edadMismaProspectoValid: boolean = false;
  public edadConductor: number = 0;
  public sexoContratante: number = 0;
  public sexoProspecto: number = 0;
  public sexoInput: string = '';
  public dataProspecto: Prospecto = new Prospecto();
  public correo: string = "";
  public inputRefSivale: boolean = false;
  public inputRefValido: boolean = false;
  conductorRef = new FormControl('');
  isLoading: boolean;
  public visible: boolean = false;
  formaPago: string;
  inputRefInterMX: boolean;

  constructor(private router: Router, private storageService: StorageService, private snackBar: MatSnackBar, private requestService: RequestServices, private modal: MatDialog) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }

  }

  ngOnInit(): void {

    if(this.storageService.ifExist('formaPago')) {
      this.formaPago = JSON.parse(this.storageService.getItem('formaPago')).formaPago;
      
    }
    
    this.inputRefSivale = (window.location.hostname === 'cochesegurosivale.inter.mx') ? true : false; 
    this.inputRefInterMX = (window.location.hostname === 'cocheseguro.inter.mx') ? true : false; 
    
    
    this.logConsumoFun.logConsumo();
    gtag({ 'event': 'formStep3View' });
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      if (cocheSeguro.isNomina) {
        this.inputRef = true;
      }
    }

    if (cocheSeguro?.contratante) {
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    } else {
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    }
    if (cocheSeguro?.cia) {
      this.cia = cocheSeguro.cia;
    }
    this.dataContratante = cocheSeguro?.contratante;
    if (cocheSeguro?.conductor) {
      this.conductor = cocheSeguro.conductor;
      if (this.conductor.mismo_conductor) {
        this.muestraOtroConcductor = 1;
      } else {
        this.muestraOtroConcductor = 0;
      }
    } else {
      // if (this.cia != 49 && this.cia != 1) {
      if (!this.conductor.mismo_conductor) {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
      } else {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
        this.conductor.fec_nac = this.dataContratante.fec_nac;
        this.conductor.fec_nac_str = this.dataContratante.fec_nac_str;
        this.conductor.rfc = this.dataContratante.rfc;
      }
    }

    if (cocheSeguro?.vehiculo) {
      this.vehiculo = cocheSeguro?.vehiculo;
    }
    if (this.storageService.ifExist("renovacion")) {
      var polizaRenovar = JSON.parse(this.storageService.getItem("renovacion"));
        this.vehiculo.serie = polizaRenovar?.serie;
        this.vehiculo.placas = polizaRenovar?.placas;
    }

    window.scrollTo(0, 0);
    this.sexoInput = cocheSeguro.prospecto.sexo == 0 ? 'Femenino' : 'Masculino';
    if (cocheSeguro.cia == 18) {
      this.conductor.sexo = cocheSeguro.prospecto.sexo == 0 ? 'F' : 'M';
      this.edadContratante = this.CalculateAge(cocheSeguro.contratante.fec_nac);
      this.sexoContratante = (cocheSeguro.contratante.sexo == 'F' ? 0 : 1);
      this.sexoProspecto = cocheSeguro.prospecto.sexo;
      this.edadConductor = this.CalculateAge(cocheSeguro.contratante.fec_nac);
      if (this.conductor.edad_cond_hab == undefined || this.conductor.edad_cond_hab == 0) {
        if (this.edadContratante == this.edadConductor && this.sexoProspecto == this.sexoContratante) {
          this.edadMismaProspectoValid = true;
          this.edadMismaProspecto = true;
          this.conductor.edad_cond_hab = this.edadConductor;
        } else {
          this.muestraOtroConcductor = 1;
          this.conductor.mismo_conductor = true;
          this.conductor.nombres = '';
          this.conductor.ap_pat = '';
          this.conductor.ap_mat = '';
          this.conductor.fec_nac = '';
          this.conductor.fec_nac_str = '';
          this.conductor.rfc = '';
        }
      } else if (this.conductor.edad_cond_hab != undefined || this.conductor.edad_cond_hab != 0) {
        if (this.edadContratante == this.edadConductor && this.sexoProspecto == this.sexoContratante) {
          this.edadMismaProspectoValid = true;
          this.edadMismaProspecto = true;
        } else {
          this.conductor.mismo_conductor = true;
        }
        this.isMismaEdad();
      }
    } else {
      this.conductor.sexo = cocheSeguro.prospecto.sexo == 0 ? 'F' : 'M';
    }

    let aseguradora_actual = parseInt(this.storageService.getItem("aseguradora_actual"));
    if (this.cia === aseguradora_actual) {
      this.visible = true;
    } else {
      this.visible = false;
    }
  }

  isMismaEdad() {
    let edadNueva: number = this.CalculateAge(this.conductor.fec_nac);
    if (edadNueva != this.edadConductor) {
      this.edadMismaProspecto = false;
      let simpleMess = this.modal.open(SimpleMessageComponent, { disableClose: true });
      simpleMess.componentInstance.accion = '';
      simpleMess.componentInstance.cancel = 'CERRAR';
      simpleMess.componentInstance.message = 'La edad debe ser igual a la capturada en la pantalla inicial.';
    } else {
      this.edadMismaProspecto = true;
      this.conductor.edad_cond_hab = this.edadConductor;
    }
  }

  CalculateAge(fecNac: string): number {
    if (fecNac.split('/').length >= 2) {
      const anio: number = parseInt(fecNac.split('/')[2]);
      const mes: number = parseInt(fecNac.split('/')[1]);
      const dia: number = parseInt(fecNac.split('/')[0]);
      const today: Date = new Date();
      const birthDate: Date = new Date(anio, mes, dia);
      let age: number = today.getFullYear() - birthDate.getFullYear();
      const month: number = (today.getMonth() + 1) - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    } else {
      return 18;
    }
  }

  next() {
    let cocheSeguro: CocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
    let negId: number = +this.storageService.getItem('negId')
    let params = {
      numeroDeSerie: this.vehiculo.serie,
      negocio_id: negId,
      jsonEntrada: {
        ...cocheSeguro
      }
    }

    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;
    cocheSeguro.prospecto = this.dataProspecto;

    this.requestService.postRequest({ projectName: new Configuration().URLQUATTROAUTOSWS, apiName: 'valida-serie', dataJSON: params }).pipe(finalize(() => this.isLoading = false)).subscribe(
      response => {
        if(response.error) {
          this.validacionSerie = false;
          this.snackBar.open(response.error, "", { duration: this.const.SNACK_BARTIME })
        } else if (response.valid) {
            this.validacionSerie = true;
            let cocheSeguro: CocheSeguro = new CocheSeguro();
            if (this.storageService.ifExist("cocheSeguro")) {
              cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            }
            if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
              let arr: Array<string> = this.conductor.fec_nac.split('/');
              if (arr.length == 3) {
                this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
              }
            }
            if (!this.conductor.mismo_conductor) {
              this.conductor.nombres = this.dataContratante.nombres;
              this.conductor.ap_pat = this.dataContratante.ap_pat;
              this.conductor.ap_mat = this.dataContratante.ap_mat;
              this.conductor.rfc = cocheSeguro.contratante.rfc;
              this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
              this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
            }
        
            cocheSeguro.vehiculo = this.vehiculo;
            cocheSeguro.conductor = this.conductor;
            
            this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
            this.updatelogConsumo();
            gtag({ 'event': 'formStep3Submit' });
            this.goPago();
        } else {
          this.validacionSerie = false;
          this.snackBar.open(response.message, "", { duration: this.const.SNACK_BARTIME })          
        }

      }
    )
  }

  back() {
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'mi-cuenta/datos-emision-renovacion';
    } else {
      this.router.navigate(['mi-cuenta/datos-emision-renovacion']);
    }
  }

  public fecNacimientoMask: any = {
    mask: [
      {
        mask: '00/00/0000',
        regex: '^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$'
      }
    ]
  };

  generaRFC(input?: number) {
    if (input && this.cia == 18) {
      //ASDREW
      this.isMismaEdad();
    }
    this.conductor.fec_nac_str = this.conductor.fec_nac.split("/")[2] + '-' + this.conductor.fec_nac.split("/")[1] + '-' + this.conductor.fec_nac.split("/")[0];
    let rfcPaso = new ValidaRFC().calcularRFC(this.conductor.ap_pat, this.conductor.ap_mat, this.conductor.nombres, this.conductor.fec_nac_str);
    this.conductor.rfc = rfcPaso;
  }

  updatelogConsumo() {
    this.logConsumoFun.logConsumo();
  }

  updateJson() {
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    if ((this.cia == 49 || this.cia == 1) && this.conductor.fec_nac != '') {
      let arr: Array<string> = this.conductor.fec_nac.split('/');
      if (arr.length == 3) {
        this.conductor.fec_nac_str = arr[2] + '-' + arr[1] + '-' + arr[0];
      }
    }
    if (!this.conductor.mismo_conductor) {
      this.conductor.nombres = this.dataContratante.nombres;
      this.conductor.ap_pat = this.dataContratante.ap_pat;
      this.conductor.ap_mat = this.dataContratante.ap_mat;
      this.conductor.rfc = cocheSeguro.contratante.rfc;
      this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
      this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
    }

    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;

    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

    let parametro = (this.storageService.ifExist("ayuda")) ? 0 : 2;
    this.logConsumoFun.logConsumo(undefined, parametro);
    this.openModalMarcame();
    this.storageService.setItem("ayuda", JSON.stringify(true));
  }

  openModalMarcame() {
    let modalAyuda = this.modal.open(CotizacionRenovacionComponent, { disableClose: false });
    modalAyuda.afterClosed().subscribe(result => {
    });
  }

  otroConductor() {
    if (this.conductor.mismo_conductor) {
      this.muestraOtroConcductor = 0;
      this.conductor.nombres = this.dataContratante.nombres + ' ' + this.dataContratante.ap_pat + ' ' + this.dataContratante.ap_mat
    } else {
      this.muestraOtroConcductor = 1;
      this.conductor.nombres = '';
      this.conductor.ap_pat = '';
      this.conductor.ap_mat = '';
      this.conductor.fec_nac = '';
      this.conductor.fec_nac_str = '';
      this.conductor.rfc = '';
    }
  }

  validSerie(event?) {
    try {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      //console.log("ValidSerie: ", cocheSeguro);
      switch (cocheSeguro.cia) {
        case 29: // QUALITAS
          if ((this.vehiculo.serie.length > 15 && this.vehiculo.serie.length < 17) || (this.vehiculo.serie.length == 17)) {
            let valiSerie = this.validacionNoSerie.validaNoSerie(this.vehiculo.serie).pipe(finalize(() => this.isLoading = false))
              .subscribe(result => {              
              if (result.ok == true) {
                valiSerie.unsubscribe();
                this.validacionSerie = true;
                this.goPago();
              } else if (result.ok == false) {
                valiSerie.unsubscribe();
                this.snackBar.open("Serie Amparada en Póliza Vigente ", "", { duration: this.const.SNACK_BARTIME })
                this.validacionSerie = false;
              } else if (result.error) {
                this.snackBar.open(result.error, "", { duration: this.const.SNACK_BARTIME });
              } else {
                this.snackBar.open("Ocurrió un problema durante el proceso", "", { duration: this.const.SNACK_BARTIME });
              }
            });
          }
          this.validacionSerie = true;
          break;
        default:   // CHUBB //HDI  // mapfre // Afrime //primero //
          if ((this.vehiculo.serie.length > 15 && this.vehiculo.serie.length < 17) || (this.vehiculo.serie.length == 17)) {
            this.validacionSerie = true;
            this.next();
          } else {
              this.validacionSerie = false;
          }
          break;
      }
    } catch (Error) {
      console.error("Error: ", Error);
    }
  }

  public validarContrasena(): void {
    if (this.dataProspecto.contrasena !== "" && this.dataProspecto.confirmar !== "") {
      if (this.dataProspecto.contrasena !== this.dataProspecto.confirmar) {
        this.dataProspecto.contrasena = "";
        this.dataProspecto.confirmar = "";
        this.snackBar.open("¡La contraseña no coincide!", "Favor de capturar la misma contraseña.", { duration: this.const.SNACK_BARTIME });
      }
    }
  }

  /*CalculateAge(): number {
    if (coche) {
      var timeDiff = Math.abs(Date.now() - this.datosDTO.datosPersonales.fechaNacimiento);
      return Math.ceil((timeDiff / (1000 * 3600 * 24)) / 365);
    } else {
      return null;
    }
  }*/

  muestraCotizaciones() {
    if(this.validSerie) {
      const  dialofRef  = this.modal.open(OpcionesSeguros, {
        height: 'auto'
      });

      dialofRef.componentInstance.noSerie = this.vehiculo.serie;
    }
  }

  goPago() {

    if(this.conductorRef.value && window.location.hostname == 'cochesegurosivale.inter.mx' || this.conductorRef.value && window.location.hostname == 'cocheseguro.inter.mx') {
      this.conductor.ref = this.conductorRef.value;            
    } 

    this.saveCocheseguroInfo();
    
    let cocheSeguro: CocheSeguro;
    if(this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
      if (!this.conductor.mismo_conductor) {
        this.conductor.nombres = this.dataContratante.nombres;
        this.conductor.ap_pat = this.dataContratante.ap_pat;
        this.conductor.ap_mat = this.dataContratante.ap_mat;
        this.conductor.rfc = cocheSeguro.contratante.rfc;
        this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
        this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
      }
      cocheSeguro.vehiculo = this.vehiculo;
      cocheSeguro.conductor = this.conductor;
      this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

      if(this.validSerie)  {
        if(cocheSeguro.cia == 18 ||  this.formaPago === 'T' || this.formaPago === 'M') {
          if (this.const.PLATFORM) {
            window.location.href = this.const.URLPLATFORM + 'mi-cuenta/datos-tarjeta-renovacion';
          } 
          this.router.navigate(['mi-cuenta/datos-tarjeta-renovacion']);
        } else {
          this.router.navigate(['mi-cuenta/opciones-pago-renovacion'], { queryParams: { aseg: cocheSeguro.cia } });
        }
      }    
    } 
  }


  nextStep() {
    this.isLoading = true;
    this.saveCocheseguroInfo();
    if (this.storageService.ifExist("renovacion")) {
      var polizaRenovar = JSON.parse(this.storageService.getItem("renovacion"));
    }
    if (this.cia === polizaRenovar.c13) {
      this.validacionSerie = true;
      this.goPago();
    } else {
      this.validSerie();
    }
  }

  saveCocheseguroInfo() {
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));

    if (!this.conductor.mismo_conductor) {
      this.conductor.nombres = this.dataContratante.nombres;
      this.conductor.ap_pat = this.dataContratante.ap_pat;
      this.conductor.ap_mat = this.dataContratante.ap_mat;
      this.conductor.rfc = cocheSeguro.contratante.rfc;
      this.conductor.fec_nac_str = cocheSeguro.contratante.fec_nac_str;
      this.conductor.fec_nac = cocheSeguro.contratante.fec_nac;
    }
    cocheSeguro.vehiculo = this.vehiculo;
    cocheSeguro.conductor = this.conductor;
    cocheSeguro.prospecto = this.dataProspecto;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
  }
 
  verificaNumeroSerie(numSerie: string): boolean | void {

  }

   keyPressSoloNumeros(event: KeyboardEvent, value: string) {
    
    if (
      event?.key == '0' ||
      event?.key == '1' ||
      event?.key == '2' ||
      event?.key == '3' ||
      event?.key == '4' ||
      event?.key == '5' ||
      event?.key == '6' ||
      event?.key == '7' ||
      event?.key == '8' ||
      event?.key == '9' ||
      event?.key == '.' ||
      event?.keyCode == 48 ||
      event?.keyCode == 49 ||
      event?.keyCode == 50 ||
      event?.keyCode == 51 ||
      event?.keyCode == 52 ||
      event?.keyCode == 53 ||
      event?.keyCode == 54 ||
      event?.keyCode == 55 ||
      event?.keyCode == 56 ||
      event?.keyCode == 57 ||
      event?.keyCode == 46
    ) {
        (<HTMLInputElement>event.target).value =
          (<HTMLInputElement>event.target).value;

    } else {
      event.preventDefault();
    }
  }

  
  validaEspacionVacios(event: KeyboardEvent) {

    if(event?.keyCode === 32 ||  (<HTMLInputElement>event.target).value.length >= 8) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value =
      (<HTMLInputElement>event.target).value;
    }

  }

}

